/**
 * @generated SignedSource<<e8c3effa65d7cb0351f3ef7f4106132e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_Header_viewResult$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SaveResetViewSettingsButton" | "hierarchyToggle_issueNavigator_HierarchyToggleItem" | "src_issueTableHideDoneToggle_HideDoneItemsToggle">;
  readonly " $fragmentType": "main_issueNavigator_Header_viewResult";
};
export type main_issueNavigator_Header_viewResult$key = {
  readonly " $data"?: main_issueNavigator_Header_viewResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_Header_viewResult">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "main_issueNavigator_Header_viewResult",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "hierarchyToggle_issueNavigator_HierarchyToggleItem"
    },
    {
      "kind": "FragmentSpread",
      "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "SaveResetViewSettingsButton"
        }
      ]
    }
  ],
  "type": "JiraIssueSearchView"
};

(node as any).hash = "896a2cd96d091446aac7516b6437620a";

export default node;
